var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 151,
    viewBox: "0 0 139 151",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7822 105.224C34.9784 104.523 34.4856 103.532 34.412 102.469C34.3384 101.405 34.69 100.356 35.3897 99.5514L56.6498 75.156C56.9971 74.7562 57.4197 74.4287 57.8935 74.1923C58.3673 73.9558 58.8831 73.815 59.4113 73.7779C59.9396 73.7407 60.47 73.808 60.9722 73.9758C61.4744 74.1437 61.9387 74.4088 62.3385 74.7561C62.7383 75.1033 63.0657 75.5259 63.3022 75.9998C63.5386 76.4736 63.6794 76.9893 63.7166 77.5176C63.7537 78.0458 63.6864 78.5762 63.5186 79.0784C63.3507 79.5807 63.0856 80.0449 62.7384 80.4447L41.4782 104.84C41.1304 105.241 40.7068 105.569 40.2317 105.805C39.7566 106.042 39.2395 106.182 38.71 106.218C38.1806 106.253 37.6493 106.184 37.1468 106.013C36.6443 105.843 36.1805 105.574 35.7822 105.224Z",
    fill: "#21282C",
    stroke: "#ACFFC5",
    strokeWidth: 0.813529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.546 81.6975L46.7103 95.1247",
    stroke: "#ACFFC5",
    strokeWidth: 0.813529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40868 142.412C2.70026 141.796 2.12015 141.046 1.70147 140.206C1.2828 139.366 1.03375 138.451 0.96859 137.515C0.903433 136.578 1.02343 135.638 1.32172 134.748C1.62001 133.858 2.09075 133.035 2.70704 132.327L33.0584 97.4929C34.3079 96.0645 36.0736 95.191 37.9672 95.0644C39.8607 94.9379 41.727 95.5688 43.1554 96.8183C44.5838 98.0678 45.4574 99.8335 45.5839 101.727C45.7104 103.621 45.0795 105.487 43.83 106.915L13.462 141.698C12.2205 143.121 10.4662 143.995 8.58249 144.129C6.69875 144.262 4.83867 143.645 3.40868 142.412Z",
    fill: "#ACFFC5",
    stroke: "#ACFFC5",
    strokeWidth: 0.813529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.643 14.2556C109.148 8.59702 101.122 4.99131 92.5782 3.89444C84.0346 2.79756 75.3576 4.25878 67.6444 8.09333C59.9313 11.9279 53.5284 17.9635 49.2455 25.437C44.9626 32.9105 42.992 41.4863 43.5829 50.0797C44.1738 58.6732 47.2998 66.8984 52.5654 73.7153C57.831 80.5322 64.9997 85.6346 73.1652 88.3772C81.3306 91.1199 90.126 91.3796 98.4391 89.1236C106.752 86.8675 114.21 82.1971 119.868 75.7028C127.454 66.9931 131.271 55.6272 130.478 44.1043C129.686 32.5814 124.35 21.8449 115.643 14.2556ZM63.3706 74.2417C58.0019 69.562 54.1413 63.3955 52.2771 56.5218C50.4128 49.6481 50.6287 42.376 52.8974 35.625C55.166 28.874 59.3855 22.9473 65.0224 18.5943C70.6593 14.2414 77.4603 11.6576 84.5656 11.1698C91.6709 10.682 98.7612 12.312 104.94 15.8537C111.119 19.3955 116.109 24.6899 119.279 31.0675C122.449 37.4451 123.657 44.6195 122.749 51.6834C121.842 58.7474 118.86 65.3837 114.182 70.7532C107.905 77.9524 99.0269 82.3642 89.4985 83.0184C79.97 83.6726 70.5718 80.5156 63.3706 74.2417Z",
    fill: "#ACFFC5",
    stroke: "#ACFFC5",
    strokeWidth: 0.813529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3351 24.4465C67.3245 21.4528 70.8778 19.0815 74.7894 17.4697C78.701 15.8579 82.8934 15.0377 87.124 15.0564",
    stroke: "#ACFFC5",
    strokeWidth: 0.813529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9548 35.9212C58.0939 32.8595 59.6964 29.9909 61.7061 27.4156",
    stroke: "#ACFFC5",
    strokeWidth: 0.813529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2159 41.0074C46.6938 30.8939 51.787 21.6586 59.5522 15.0125C67.3173 8.36642 77.2281 4.75988 87.4485 4.86096C97.669 4.96205 107.506 8.76393 115.139 15.5623C122.771 22.3607 127.68 31.6949 128.958 41.8357",
    stroke: "#21282C",
    strokeWidth: 1.0847,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.087 57.1158C125.705 66.9705 119.859 75.6403 111.617 81.5436C103.374 87.4468 93.284 90.19 83.1871 89.2725C73.0902 88.3551 63.6597 83.8382 56.6161 76.546C49.5725 69.2538 45.3853 59.6724 44.8185 49.5497",
    stroke: "#21282C",
    strokeWidth: 1.0847,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.263 45.8518C129.351 48.7386 129.142 51.6268 128.64 54.4709",
    stroke: "#21282C",
    strokeWidth: 1.0847,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8661 124.341C21.0212 124.774 22.3089 124.189 22.7422 123.034C23.1756 121.879 22.5904 120.591 21.4353 120.157C20.2802 119.724 18.9925 120.309 18.5591 121.464C18.1258 122.62 18.711 123.907 19.8661 124.341Z",
    fill: "#21282C",
    stroke: "#ACFFC5",
    strokeWidth: 0.813529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1507c6ec99c81f8078d3975165b5606e.svg";
export { ForwardRef as ReactComponent };